var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleBuilderGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9744 1.70825H20.7926V22.2917H18.9744V24H24.4996V22.2917H22.6713V1.70825H24.4996V0H18.9744V1.70825ZM7.88384 22.2915H11.5909V6.8515H18.9545V3.435H0.5V6.8515H7.88384V22.2915Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleBuilderGrey);
export default __webpack_public_path__ + "static/media/title-builder-grey.871f682aa0332ea552f4a5bd818b0bb4.svg";
export { ForwardRef as ReactComponent };